import { IUserAccessStatusToRegistration } from 'legacy/lut/classes/models/onboarding/IUserAccessStatusToRegistration'
import { RequestTypes } from 'legacy/lut/classes/models/onboarding/Onboarding'
import OnboardingApi from 'legacy/lut/classes/services/api/OnboardingApi'
import { WARNING_MESSAGE } from 'legacy/lut/components/widgets/public/onboarding/bpRegistration/helpers/checkAccess'

class OnboardingRegistrationAccessHelper {
  public isTokenValid = (
    token: string,
    requestId: number
  ): Promise<{ hasAccess: boolean; warningMessage: string; email?: string }> => {
    return OnboardingApi.getUserAccessToRegistrationByToken(token, requestId)
  }
  public checkEmailAccessToEditRegistration = async (email: string, requestType?: RequestTypes) => {
    if (requestType) {
      const result = await OnboardingApi.getUserAccessToRegistrationByEmail(email, requestType)

      const warningMessage = this.getWarningMessage(result)
      return {
        warningMessage,
        redirectRid: result?.ExistsRegistration,
        requestWasRejected: !!result?.RejectedReason,
      }
    }
    return { warningMessage: this.getWarningMessage(null), requestWasRejected: false }
  }

  public checkEmailAccessToUpdateDistributorsOnBehalf = (
    email: string,
    requestId: number
  ): Promise<boolean> => {
    return OnboardingApi.getUserAccessToUpdateDistributorsOnBehalfByEmail(email, requestId)
  }

  private getWarningMessage = (data: IUserAccessStatusToRegistration | null) => {
    if (!data) {
      return WARNING_MESSAGE.somethingWentWrong
    }

    if (data.RejectedReason) {
      return data.RejectedReason
    }

    if (data.IsHPA) {
      return WARNING_MESSAGE.isHPA
    }

    if (data.ShowUseLinkMessage) {
      return WARNING_MESSAGE.useInviteLink
    }
    return null
  }
}

export const onboardingRegistrationAccessHelper = new OnboardingRegistrationAccessHelper()
